export enum Fuel {
	Diesel = 'Diesel',
	Electric = 'Electric',
	FuelCell = 'Fuel cell',
	Gas = 'Gas',
	GasBiFuel = 'Gas bi-fuel',
	Hybrid = 'Hybrid',
	Other = 'Other',
	Petrol = 'Petrol',
}
